export const lowSeverity = {
  color: 'orange'
};
export const highSeverity = {
  color: 'red'
};
